import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// CDK imports for advanced components
export const CDK_IMPORTS = [A11yModule, OverlayModule, PortalModule, CdkTableModule, DragDropModule];

// Import categories for different component types
export const FORM_IMPORTS = [FormsModule, ReactiveFormsModule];
